module.exports = __webpack_public_path__ + "static/media/AudioImg.645595aa.jpg";